import _ from 'lodash';

const getCepCardState = state => _.get(state, 'PointOfSaleState.cepCard');

export const getServedMealsCount = state =>
  _.get(getCepCardState(state), 'servedMealsCount', 0);

export const getLastMealServedAt = state =>
  _.get(getCepCardState(state), 'lastMealServedAt');

export const getMealCounterFetching = state =>
  _.get(getCepCardState(state), 'fetching');

export const getProcessedMealsCount = state =>
  _.get(getCepCardState(state), 'processedMealsCount', 0);

export const getHasUnprocessedMeals = state =>
  getServedMealsCount(state) > getProcessedMealsCount(state);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/state/selectors.js